import '../../css/base.css';

const WalkHighlandsGlenelg = () => {

  const redirectToWalkhighlands = () => {
    window.open("https://www.walkhighlands.co.uk/kintail/glenelg.shtml");
  }
  return (
    <div>
      <h2 className="walks-link-heading"><a  onClick={redirectToWalkhighlands}>Walking Routes</a></h2>
      <p className="walk-text">Walkhighlands is a fabulous website for finding walking routes in Scotland.  It caters for low level and mountain routes
                                The link here takes you to the specific area for Glenelg and Arnisdale but you can explore other areas of Scotland.
      </p>                                            
    </div>
  );
}

export default WalkHighlandsGlenelg
